import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { AppHeader } from '@/design-system/AppHeader';
import { AppShell } from '@/design-system/AppShell';
import { EnvBadge } from '@/design-system/EnvBadge';
import { NavRail } from '@/design-system/NavRail';
import { AuthProvider } from '@/auth/AuthProvider';
import { useHubUser, useSignOut } from '@/auth/hooks';
import { useEnvStore } from '@/env/envStore';
import { ThemeProvider } from '@/theme/ThemeProvider';
import { AppRoutes } from '@/routes/AppRoutes';
import { useNavItems } from '@/routes/navItems';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function ChromeShell() {
  const { env, setEnv } = useEnvStore();
  const user = useHubUser();
  const signOut = useSignOut();
  const navItems = useNavItems();

  return (
    <AppShell
      header={
        <AppHeader
          left={<EnvBadge env={env} onChange={setEnv} />}
          user={{ name: user.name, email: user.email }}
          onSignOut={signOut}
        />
      }
      nav={<NavRail items={navItems} groupLabel="Sections" />}
    >
      <AppRoutes />
    </AppShell>
  );
}

export function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BrowserRouter>
            <ChromeShell />
          </BrowserRouter>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
